/**
 * Who a newly approved Sales Partner goes to (25 October 2026), as plain
 * functions so the rules are tested without a browser. The approve call
 * (POST /admin/sales-flow/applications/:id/approve) takes staff_id:
 * omitted, the referring rep the application resolved to; null, the EVI
 * house book; an id, that person. The screen never sends a suggested person
 * unless the Super Admin picked them.
 */

export type ApprovalAssign = 'referral' | 'house' | 'manager';

export function approvalStaffChoice(assign: ApprovalAssign, staffId: string): { ok: boolean; body: { staff_id?: string | null } } {
  if (assign === 'referral') return { ok: true, body: {} };
  if (assign === 'house') return { ok: true, body: { staff_id: null } };
  return /^[a-f0-9]{24}$/i.test(staffId) ? { ok: true, body: { staff_id: staffId } } : { ok: false, body: {} };
}

export interface PickStaff { _id: string; name?: string; email?: string; role?: 'rep' | 'manager'; end_date?: string | null }

/** Active sales staff for the picker: the suggested people first, in the
 *  suggestion's order, then everyone else by name. */
export function staffPickList<T extends PickStaff>(staff: readonly T[], suggestedIds: readonly string[]): { suggested: T[]; others: T[] } {
  const active = staff.filter((s) => !s.end_date);
  const byId = new Map(active.map((s) => [s._id, s]));
  const suggested = suggestedIds.map((id) => byId.get(id)).filter((s): s is T => !!s);
  const taken = new Set(suggested.map((s) => s._id));
  const others = active.filter((s) => !taken.has(s._id))
    .sort((a, b) => (a.name ?? a.email ?? '').localeCompare(b.name ?? b.email ?? ''));
  return { suggested, others };
}
